import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { productionBatchStatistics } from '@reducers/statistics';
import { updateHeaderConfig } from '@reducers/details';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';

interface BatchDetailsBatchEventsSetupProps {}

const BatchDetailsBatchEventsSetupComponent: FC<BatchDetailsBatchEventsSetupProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  const { batchId } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL), flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.SETUP, productionBatchId: batchId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const BatchDetailsBatchEventsSetup = connect(null, {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsBatchEventsSetupComponent);

export { BatchDetailsBatchEventsSetup };
